// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__L_TRq","list":"BalanceDue_list__16jur","listRow":"BalanceDue_listRow__2Kmzq","total":"BalanceDue_total__1p5RC"};